export const blockIconsPhotoandimageBrightness6New = (
	<span className='material-symbols-outlined'>brightness_6</span>
);
